import { $httpChangiRecommends } from '@/core/api';
import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            promobars: [],
            positionZero: true,
        };
    },
    created() {
        try {
            $httpChangiRecommends.api.ChangiRecommendsPromoBars().then((resp) => {
                this.promobars = resp.data;
            });
        }
        catch (error) {
        }
    },
});
